// TEALBEE CUSTOM: Q4 promo window logic — see CUSTOMIZATIONS.md
// One date check for the whole site. Reads the JSON that
// snippets/q4-promo-schedule.liquid renders, decides which promo window is
// live, and shows/hides the q4-deal-window sections on /pages/deals.
// window.Q4Promo.activeWindow(now) is public so other code (e.g. a future
// cart bar switch) can reuse the same decision.
(function () {
  if (window.Q4Promo && window.Q4Promo.init) return;

  // The date check lives in snippets/tealbee-q4-promo-boot.liquid (rendered in
  // <head> on every page). This file only adds the deals-page show/hide.
  // The fallback below keeps the deals page working if the boot snippet is
  // ever removed; it is the same logic, kept in one place on purpose.
  var core = window.Q4Promo;
  if (!core) {
    var cache = null;
    var schedule0 = function () {
      if (cache) return cache;
      var el = document.querySelector('[data-q4-schedule]');
      var list = [];
      try { list = el ? JSON.parse(el.textContent) : []; } catch (e) { list = []; }
      cache = list.map(function (w) { w.startMs = Date.parse(w.start); w.endMs = Date.parse(w.end); return w; });
      return cache;
    };
    var designMode0 = function () { return !!(window.Shopify && window.Shopify.designMode); };
    var now0 = function () {
      var role = window.Shopify && window.Shopify.theme && window.Shopify.theme.role;
      if (designMode0() || (role && role !== 'main')) {
        var m = /[?&]q4_preview=([^&]+)/.exec(location.search);
        if (m) {
          var v = decodeURIComponent(m[1]);
          if (!/[zZ]|[+-]\d\d:?\d\d$/.test(v)) v += '-08:00';
          var t = Date.parse(v);
          if (!isNaN(t)) return t;
        }
      }
      return Date.now();
    };
    core = {
      schedule: schedule0,
      now: now0,
      designMode: designMode0,
      activeWindow: function (t) {
        t = t == null ? now0() : t;
        var list = schedule0();
        for (var i = 0; i < list.length; i++) if (t >= list[i].startMs && t < list[i].endMs) return list[i];
        return null;
      }
    };
  }
  var schedule = core.schedule, now = core.now, activeWindow = core.activeWindow;
  function designMode() { return core.designMode ? core.designMode() : !!(window.Shopify && window.Shopify.designMode); }

  function status(w, t) {
    if (t < w.startMs) return 'scheduled';
    if (t >= w.endMs) return 'ended';
    return 'LIVE';
  }

  function show(el) {
    var img = el.querySelectorAll('.q4-hero__img img');
    for (var i = 0; i < img.length; i++) {
      img[i].loading = 'eager';
      img[i].setAttribute('fetchpriority', 'high');
    }
    el.hidden = false;
  }

  function init() {
    var wins = document.querySelectorAll('.q4-window');
    if (!wins.length) return;
    var t = now();
    var live = activeWindow(t);
    var editor = designMode();
    var forced = editor && document.querySelector('.q4-window[data-force="true"]');
    var byId = {};
    schedule().forEach(function (w) { byId[w.id] = w; });

    for (var i = 0; i < wins.length; i++) {
      var el = wins[i];
      var id = el.getAttribute('data-window-id');
      var isFallback = el.getAttribute('data-fallback') === 'true';
      var entry = byId[id];
      var visible;

      if (editor) {
        visible = forced ? el.getAttribute('data-force') === 'true' : true;
        var label = el.querySelector('.q4-editor-label');
        if (label) {
          label.textContent = entry
            ? id.toUpperCase() + ' · ' + status(entry, t) + ' · ' + new Date(entry.startMs).toLocaleDateString(undefined, { month: 'short', day: 'numeric' }) + '–' + new Date(entry.endMs).toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
            : (isFallback ? 'EVERYDAY · shows when no promo is live' : id.toUpperCase() + ' · not in schedule (off)');
        }
      } else if (live) {
        visible = !!entry && entry.id === live.id;
      } else {
        visible = isFallback;
      }

      if (visible) show(el); else el.hidden = true;
    }

    // "Coming up" teasers hide themselves once the window they point at has started.
    var teasers = document.querySelectorAll('.q4-teaser[data-next-start]');
    for (var j = 0; j < teasers.length; j++) {
      var ns = Date.parse(teasers[j].getAttribute('data-next-start'));
      if (!isNaN(ns) && t >= ns) teasers[j].hidden = true;
    }
  }

  core.init = init;
  window.Q4Promo = core;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function () { init(); });
})();
// END TEALBEE CUSTOM
